<template>
  <v-flex fill fill-height horizontal>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <div class="header-section">
        <h1>{{ season.name }} - {{ player.name | shortName }}</h1>
      </div>
      <section class="elavation-1">
        <v-layout wrap>
          <v-flex
            xs12
            pb-3
            v-bind:key="`${seasonId}-${playerId}-${stats.division}`"
            v-for="stats in playerStats.divisionStats"
          >
            <division-summary :stats="stats"></division-summary>
          </v-flex>
        </v-layout>
        <v-layout v-if="season.track_hole_scores">
          <v-flex xs12 pb-3>
            <v-card>
              <v-card-title>
                <h2>Player vs Season Hole Avg</h2>
              </v-card-title>
              <v-card-text>
                <player-season-hole-chart
                  :player="playerStats.playerHoles"
                  :season="playerStats.seasonHoles"
                ></player-season-hole-chart>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 pb-3>
            <v-card>
              <v-card-title>
                <h2>Points vs Par</h2>
              </v-card-title>
              <v-card-text>
                <player-points-chart
                  :weeks="weeks"
                  :weekly-stats="playerStats.weeks"
                ></player-points-chart>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </section>
    </div>
  </v-flex>
</template>

<script>
import DivisionSummary from "./shared/DivisionSummary";
import PlayerSeasonHoleChart from "./shared/PlayerSeasonHoleChart";
import PlayerPointsChart from "./shared/PlayerPointsChart";

export default {
  name: "PlayerSummary",
  components: {
    DivisionSummary,
    PlayerSeasonHoleChart,
    PlayerPointsChart,
  },
  props: ["seasonId", "seasonName", "playerId", "playerName"],
  data() {
    return {
      loading: false,
      divisions: null,
      error: null,
      season: null,
      weeks: null,
      player: null,
      playerStats: null,
    };
  },
  methods: {
    async fetchData() {
      this.error = this.divisions = null;
      this.loading = true;
      try {
        const results = await Promise.all([
          this.$apiClient.seasons(this.seasonId),
          this.$apiClient.weeks(this.seasonId),
          this.$apiClient.players(this.playerId),
          this.$apiClient.playerStats(this.seasonId, this.playerId),
        ]);

        this.season = results[0].data;
        this.weeks = results[1].data;
        this.player = results[2].data;
        this.playerStats = results[3].data;
      } catch (e) {
        this.error = e;
      }

      this.loading = false;
    },
  },
  watch: {
    $route: "fetchData",
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
